import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    estatusProgramacion: [],
  },

  getters: {
    getEstatusProgramacion: (state) => state.estatusProgramacion,
  },

  mutations: {
    SET_ESTATUS_PROGRAMACION(state, estatusProgramacion) {
      state.estatusProgramacion = estatusProgramacion;
    },
  },

  actions: {
    async fetchEstatusProgramacion({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catestatusProgramacion')
        .then((response) => {
          commit('SET_ESTATUS_PROGRAMACION', response.data.data);
        });
    },
  },
};
